angular.module('impactx.search').service('SearchExecution', [
    'dataGen',
    SearchExecution
]);

function SearchExecution(dataGen) {

    function searchProducts(filters, pageSize, pageNumber) {
        var result = {};
        return dataGen.postAsForm(result, {
            filters: filters,
            pagenumber: pageNumber,
            pagesize: pageSize,
            cscId: 0,
            justNewProducts: true,
            checkOutCatId: 0,
            rfqhId: 0
        }, '/search/productsinfinite', false, true).then(function () {
            return impactX.isDefined(result, 'data.searchResults');
        });
    }

    function searchTenders(filters, pageSize, pageNumber) {
        var result = {};
        return dataGen.postAsForm(result, {
            filters: filters,
            pageNumber: pageNumber,
            pageSize: pageSize,
        }, '/search/tender/infinite', false, true).then(function () {
            return result;
        });
    }

    function searchLots(filters, pageSize, pageNumber) {
        var result = {};
        return dataGen.postAsForm(result, {
            filters: filters,
            pageNumber: pageNumber,
            pageSize: pageSize,
        }, '/search/lot/infinite', false, true).then(function () {
            return result;
        });
    }

    function searchCatalogs(filters, pageSize, pageNumber) {
        var result = {};
        return dataGen.postAsForm(result, {
            filters: filters,
            pageNumber: pageNumber,
            pageSize: pageSize,
        }, '/search/catalog/infinite', false, true).then(function () {
            return result;
        });
    }

    function searchSuppliers(filters, pageSize, pageNumber) {
        var result = {};
        return dataGen.postAsForm(result, {
            filters: filters,
            pageNumber: pageNumber,
            pageSize: pageSize,
        }, '/search/supplier/infinite', false, true).then(function () {
            return result;
        });
    }

    return {
        searchProducts: searchProducts,
        searchTenders: searchTenders,
        searchLots: searchLots,
        searchCatalogs: searchCatalogs,
        searchSuppliers: searchSuppliers,
    };
}